const ShipmentPointsGraphQL = {
    TO_PICKUP: 0,
    TO_DELIVERY: 1,
};

export default ShipmentPointsGraphQL;
